import Breadcrumbs from "../../../components/breadcrumbs";
import DietaryPreferenceCreateForm from "./ui/dietary-preference-create-form";

export default function DietaryPreferenceCreatePage(){
     return (
            <main className="max-w-3xl ">
              <Breadcrumbs
                breadcrumbs={[
                  { label: "Dietary Preferences", href: "/admin/dietary-preferences" },
                  {
                    label: "create",
                    href: `/admin/dietary-preferences/Create`,
                    active: true,
                  },
                ]}
              />
              
                <DietaryPreferenceCreateForm/>
              
            </main>
          );
        }



